export const pushNextRoute = (pathData) => {
  const meta = pathData?.meta ?? {}

  const nextRoute = {
    event: "nextRoute",
    path: pathData.path,
    env: meta?.env || "stage",
    context: meta?.context
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(nextRoute)
}
